import { useMemo, useState } from "react";
import { DropdownSectionData } from "../types";

export const useSections = (
  sections: DropdownSectionData[],
  defaultValue: string | number
) => {
  const [searchQuery, setSearchQuery] = useState("");
  const filteredSections = useMemo(() => {
    if (!searchQuery.trim()) {
      return sections;
    }

    const query = searchQuery.toLowerCase();
    return sections
      .map((section) => ({
        ...section,
        options: section.options.filter((option) =>
          option.label.toLowerCase().includes(query)
        ),
      }))
      .filter((section) => section.options.length > 0);
  }, [sections, searchQuery]);

  const allOptions = useMemo(
    () =>
      filteredSections.flatMap((section) =>
        section.options.map((option) => option.value)
      ),
    [filteredSections]
  );

  const selectedLabel = useMemo(
    () =>
      filteredSections
        .flatMap((section) => section.options)
        .find((option) => option.value === defaultValue)?.label,
    [filteredSections, defaultValue]
  );

  return {
    filteredSections,
    allOptions,
    selectedLabel,
    hasMultipleSections: filteredSections.length > 1,
    searchQuery,
    setSearchQuery,
  };
};
